'use strict';

import { getLiffProfile } from "./LiffService.js";
import { getJSONWithExpiry, setJSONWithExpiry, HOUR_IN_MILLIS } from "./ExpiryStorage.js";
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAWEb6DiUVUE7iYyFEJCTgVQvzB1SVNtWA",
  authDomain: "tueyhom.firebaseapp.com",
  databaseURL: "https://tueyhom.firebaseio.com",
  projectId: "tueyhom",
  storageBucket: "tueyhom.appspot.com",
  messagingSenderId: "992887324097",
  appId: "1:992887324097:web:81bd306f36dcd51294c340",
  measurementId: "G-7CFWGN0LRE"
};
const app = firebase.initializeApp(firebaseConfig);
var firestore = firebase.firestore(app);
firebase.firestore().enablePersistence()
  .catch(function (err) {
    console.log(err);
  });
var storage = firebase.storage();

let authPromise;
export function auth() {
  if (authPromise == null) {
    authPromise = new Promise(function (resolve, reject) {
      getLiffProfile().then(async function (profile) {
        let signin = function (customToken) {
          firebase.auth().signInWithCustomToken(customToken).then(function () {
            resolve();
          }).catch(function (err) {
            console.log(err);
            reject();
          });
        };

        let key = "FIRESTORE_TOKEN_" + liff.getAccessToken();
        let customToken = getJSONWithExpiry(key);
        if (customToken) {
          signin(customToken);
        } else {
          fetch('https://asia-east2-tueyhom.cloudfunctions.net/createCustomToken', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
              "access_token": liff.getAccessToken(),
              "id": profile.userId,
              "name": profile.displayName,
              "picture": profile.pictureUrl,
              "email": liff.getDecodedIDToken().email
            })
          }).then(function (resp) {
            return resp.json();
          }).then(function (resp) {
            customToken = resp.firebase_token;
            setJSONWithExpiry(key, customToken, HOUR_IN_MILLIS);
            signin(customToken);
          });
        }
      });
    });
  }
  return authPromise;
}

export async function getFirebase() {
  return auth().then(function () {
    return firebase;
  });
}

export async function getSecuredFirestore() {
  return auth().then(function () {
    return firestore;
  });
}

export async function getFirestore() {
  return firestore;
}

export async function getStorage() {
  return auth().then(function () {
    return storage;
  });
}

export async function getCachedFirst(ref) {
  return auth().then(function () {
    return ref.get({ source: 'cache' }).then(function (snapshot) {
      if ((snapshot instanceof firebase.firestore.DocumentSnapshot && !snapshot.exists) || (snapshot instanceof firebase.firestore.QuerySnapshot && snapshot.empty)) {
        return ref.get({ source: 'server' });
      } else {
        return snapshot;
      }
    }).catch((e) => ref.get({ source: 'server' }));
  });
}

export { firebase };